import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { closeProhibitedTerritoriesModal } from '@/store/slices/modalSlice';
import useOutsideClick from '@/hooks/useOutsideClick';
import { Icons } from '@/utils/icons';
import { useLocation } from 'react-router-dom';
import useModalAnimation from '@/hooks/useModalAnimation';

const ProhibitedTerritoriesModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector((state) => state.modal.isProhibitedTerritoriesModalOpen);
  const modalRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const isTermsOrResponsiblePage =
    location.pathname === '/terms-and-conditions' || location.pathname === '/responsible-gaming';

  const { animate, handleClose } = useModalAnimation({
    isOpen,
    onClose: () => dispatch(closeProhibitedTerritoriesModal()),
  });

  useOutsideClick(modalRef, handleClose);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={`fixed inset-0 z-[999] flex items-center justify-center bg-black/50 pt-10 px-4 ${isTermsOrResponsiblePage ? 'font-noto' : 'font-roboto'}`}
    >
      <div
        ref={modalRef}
        className={`w-full max-w-[500px] bg-white shadow-md shadow-black/50 rounded-sm overflow-hidden transform transition-all duration-300 ease-out ${animate ? 'translate-y-0 opacity-100' : '-translate-y-6 opacity-0'}`}
      >
        <div
          className={`bg-primary flex justify-between items-center ${isTermsOrResponsiblePage ? 'p-4' : 'p-2'}`}
        >
          <h2 className="text-xl text-black">Prohibited Territories</h2>
          <button onClick={handleClose} className="hover:opacity-70 transition-opacity">
            <Icons.plusBold className="text-base text-black rotate-45" />
          </button>
        </div>

        <div
          className={` text-primary-dark-grey ${isTermsOrResponsiblePage ? 'text-base p-4' : 'text-sm px-2 py-3 leading-normal'}`}
        >
          <p className="mb-4">
            The right to prohibit betting on the Website by customers, whether acting alone, in a
            syndicate or via an AGENT or Sub-agent, where such customers are resident in Prohibited
            Jurisdictions. As of the Commencement Date, the following are Prohibited Jurisdictions:
          </p>
          <p className="mb-4">
            Algeria, Australia, Austria, Bulgaria, Canada, Cyprus, the Czech Republic, Democratic
            People&apos;s Republic of Korea, Denmark, Europe, France (and French territories),
            Germany, Gibraltar, Iran, Iraq, Ireland, Italy, Malta, Myanmar, New Zealand, Poland,
            Portugal, Qatar, Romania, Singapore, South Africa, Spain, Turkey, the United Kingdom,
            the United States of America and its territories, and any other territories that Betfair
            may notify the operator.
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProhibitedTerritoriesModal;
